import { Navigate } from "react-router-dom";

import { RVRoutingPage } from "@regal-voice/ui";
import { useFlags } from "Services/FeatureFlagService";

export default function EventManagementRouter(): JSX.Element {
    const { adminSettings } = useFlags();

    if (!adminSettings) {
        return <Navigate to={"/"} />;
    }

    return <RVRoutingPage />;
}
